"use strict";

var _createForOfIteratorHelper = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hoistVariables;

var _t = require("@babel/types");

var assignmentExpression = _t.assignmentExpression,
    expressionStatement = _t.expressionStatement,
    identifier = _t.identifier;
var visitor = {
  Scope: function Scope(path, state) {
    if (state.kind === "let") path.skip();
  },
  FunctionParent: function FunctionParent(path) {
    path.skip();
  },
  VariableDeclaration: function VariableDeclaration(path, state) {
    if (state.kind && path.node.kind !== state.kind) return;
    var nodes = [];
    var declarations = path.get("declarations");
    var firstId;

    var _iterator = _createForOfIteratorHelper(declarations),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var declar = _step.value;
        firstId = declar.node.id;

        if (declar.node.init) {
          nodes.push(expressionStatement(assignmentExpression("=", declar.node.id, declar.node.init)));
        }

        for (var _i = 0, _Object$keys = Object.keys(declar.getBindingIdentifiers()); _i < _Object$keys.length; _i++) {
          var name = _Object$keys[_i];
          state.emit(identifier(name), name, declar.node.init !== null);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (path.parentPath.isFor({
      left: path.node
    })) {
      path.replaceWith(firstId);
    } else {
      path.replaceWithMultiple(nodes);
    }
  }
};

function hoistVariables(path, emit) {
  var kind = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "var";
  path.traverse(visitor, {
    kind: kind,
    emit: emit
  });
}